import React from 'react'
import './container3.css';
import ResponsiveEmbed from 'react-responsive-embed';
export default function Container5() {
  return (
    <div className='container my-5'>
    
    <div className='row pt-3 contflex3'>
    <div className='col-lg-6 col-md-12 col-sm-12 contf1'>
    <h1 className='py-2 fw-bold d-lg-none fs-2'>Grandiose Werbeanzeigen</h1>
        {/*<img src="./s2.png" className='img-fluid text-center my-1' alt='not found'/>*/}
        
        <ResponsiveEmbed src='https://staging.piiscreen.de/api/pii-screen?did=0' allowfullscreen />


    </div>
    <div className='col-lg-6 col-md-12 col-sm-12 contf2'>
        <h1 className='py-2 fw-bold d-none d-lg-block fs-2'>Grandiose Werbeanzeigen</h1>
        <p className='pb-4 cont3para'>Wir bieten unseren Kunden die Möglichkeit, ihre Werbung mit unseren Grafikdesignern zu gestalten. Dabei achten wir stets darauf, dass alle Grafiken und Werbebotschaften im Einklang mit Deiner Corporate Identity Richtlinie steht. Und das Beste: Dieser Service ist für Dich vollkommen kostenlos! So kannst Du Dich voll und ganz auf Dein Geschäft konzentrieren, während wir uns um Deine Werbung kümmern.</p>
        <a href='https://werbenetzwerk.piiscreen.de/kontakt-formular' className='flinktext text-success1'><button className='btn btn-success'>Das will ich</button></a><a href="https://werbenetzwerk.piiscreen.de/kontakt-formular" className='ps-2 text-success1'>KOSTENLOSES ERSTGESPRÄCH</a>
    </div>
    </div>
    
</div>
  )
}
